import React from 'react';
import { Row, Col, Card, CardBody, Button, Container } from 'reactstrap';
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from 'react-i18next';

function Login() {
    const { loginWithRedirect } = useAuth0();
    const { t } = useTranslation();
    const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;

    const registerWithAuth0 = () => {
        loginWithRedirect({
            authorizationParams: {
                screen_hint: 'signup',
                redirect_uri: redirectUri}}
        )
    }

    return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 background-container">
            <Row className="w-100">
                <Col sm="6" md="6" lg="4" xl="3" className="mx-auto">
                    <Card  style={{backgroundColor: "#0f172a"}}>
                        <CardBody>
                            <h4 className="text-center mb-4">{t('login.title')}</h4>
                            <div>
                                <Button className="text-center" onClick={() => loginWithRedirect()} color="primary" block>{t('login.button')}</Button>
                            </div><div>
                                <Button className="text-center" onClick={registerWithAuth0} color="secondary" block>{t('login.register')}</Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
